export const confirmationWindow = {
    state: {
        showConfirmationWindow: false,
        confirmationWindowConfig: {
            message: '',
            header: '',
            abortButtonText: '',
            confirmButtonText: '',
            confirmationWindowLoadingText: '',
            abortButtonCallback: null,
            confirmButtonCallback: null
        }
    },
    mutations: {
        SET_CONFIRMATION_WINDOW_SHOW(state, payload) {
            state.showConfirmationWindow = payload
        },
        SET_CONFIRMATION_WINDOW_CONFIG(state, payload) {
            state.confirmationWindowConfig = payload
        }
    },
    actions: {
        closeConfirmationWindow({ commit }) {
            commit('SET_CONFIRMATION_WINDOW_SHOW', false)
        },
        openConfirmationWindow({ commit }, payload) {
            commit('SET_CONFIRMATION_WINDOW_CONFIG', payload)
            commit('SET_CONFIRMATION_WINDOW_SHOW', true)
        }
    },
    getters: {
        confirmationWindowConfig: state => state.confirmationWindowConfig,
        showConfirmationWindow: state => state.showConfirmationWindow
    }
}
